import axios from 'axios';
import Cookies from 'js-cookie';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(Cookies.get('authToken'));
  const setToken_ = (newToken) => {
    setToken(newToken);
  };

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      Cookies.set('authToken', token);
    } else {
      delete axios.defaults.headers.common['Authorization'];
      Cookies.remove('authToken');
    }
  }, [token]);

  const contextValue = useMemo(
    () => ({
      token,
      setToken_,
    }),
    [token],
  );
  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthProvider;
